module.exports = __webpack_public_path__ + "9779d9a1/img/note-list-icon.961c1485.svg";